import { render, staticRenderFns } from "./TaskContext.vue?vue&type=template&id=44c4733a"
import script from "./TaskContext.vue?vue&type=script&lang=js"
export * from "./TaskContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports